import { data } from '../../svg/Store/data';
import { makeIcon } from '../makeIcon';

export const Store = makeIcon(data, 'store', 'Store');

export default Store;
